import { Button, Header, Paragraph, StarOutlineIcon } from "@datagame/ui";
import { useMutation } from "@apollo/client";
import { useTranslation } from "react-i18next";
import classNames from "classnames/bind";

import { useUser } from "../../../hooks/user/useUser";
import { STRIPE_PORTAL_SESSION_CREATE } from "../../../graphql/mutations/UserMutations";
import { Plan } from "../Plan";
import { plans } from "../../../pages/ActivatePage/ActivatePage";
import { PlanName } from "../../../gql/graphql";

import styles from "./SubscriptionView.module.scss";

const cx = classNames.bind(styles);

export const SubscriptionView = () => {
  const { t } = useTranslation();

  const { user } = useUser();

  const [createPortalSession] = useMutation(STRIPE_PORTAL_SESSION_CREATE, {
    onCompleted: (data) => {
      window.location.replace(data.stripePortalSessionCreate.url);
    },
  });

  const handleManageSubscription = () => {
    createPortalSession();
  };

  return (
    <div className={styles.container}>
      <div className={styles.subscriptionContainer}>
        <div className={cx("section", "manageSection")}>
          <div className={styles.manageSectionHeader}>
            <Header variant="h5">{t("subscription:title")}</Header>
            <Paragraph size="small" color="secondary">
              {t("subscription:manageDescription")}
            </Paragraph>

            {user?.organization.manuallyManagedPlan === PlanName.Admin && (
              <Paragraph weight="font-bold">{t("subscription:adminPlan")}</Paragraph>
            )}
          </div>
          <Button
            iconSide="left"
            icon={<StarOutlineIcon />}
            className={styles.button}
            onClick={handleManageSubscription}
          >
            {t("subscription:manage")}
          </Button>
        </div>

        <div className={cx("section", "plansSection")}>
          {plans.map((plan, index) => (
            <Plan key={index} plan={plan} selected={user?.organization.subscription?.planName === plan.name} />
          ))}
        </div>
      </div>
    </div>
  );
};
